import React, {Component} from 'react'
import {Button} from "react-bootstrap";
import AdminService from "../AdminService";

export default class NowaKategoria extends Component {

    constructor(props) {
        super(props);

        this.state = {
            tytul: ''
        };

        this.handleTytulChange = this.handleTytulChange.bind(this)
    }

    handleTytulChange(e) {
        this.setState({tytul: e.target.value})
    }

    uploadKategoria() {
        AdminService.postKategoria(this.state.tytul)
            .then(function (response) {
                this.props.goZarzadzanie()
            }.bind(this))
    }

    render() {
        return <div className="aktualnosciTabContainer">

            <div className="aktualnosciOpis">
                Aby dodać nowy wpis należy uzupełnić wszystkie pola, oraz dodać zdjęcia. Wpis można później edytować
                przez zakładkę
                <span style={{cursor: 'pointer'}} onClick={() => this.props.goZarzadzanie()}>
                    <b> zarządzanie</b>
                </span>.
            </div>
            <div className="nowyWpisForm">
                <div className="field">Nazwa<font style={{color: 'red'}}>*</font>:
                    <input type="text" value={this.state.tytul} onChange={this.handleTytulChange}
                           className="form-control"/></div>
            </div>
            <hr/>
            <div className="text-right">
                <Button
                    bsStyle={this.state.tytul !== '' ? 'success' : 'disabled'}
                    disabled={this.state.tytul === ''}
                    onClick={() => this.uploadKategoria()}>Dodaj kategorię</Button>
            </div>
        </div>
    }

}



// WEBPACK FOOTER //
// ./src/components/admin/adminComponents/stronyComponents/NowaKategoria.js